export default {
  data: function () {
    return {
      actionBoxIsFixed: false,
    };
  },
  computed: {
    useFixedActionBox() {
      if (this.actionBoxIsFixed) {
        return true;
      }
      return this.pageYOffset >= 130;
    },
    actionBoxClass() {
      return {
        class: `user-action-box user-action-box-${this.useFixedActionBox ? 'fixed' : 'flowing'}`,
        // 74 is the height of the action box per SCSS file
        // class .user-action-box-fixed
        // industry-solution/is-ui/src/styles/material-dashboard/_misc.scss
        style: this.useFixedActionBox ? `top: ${74 + this.$store.state.app.bannerHeight}px;` : '',
      };
    },
    actionBoxGradientClass() {
      return `actions-gradient actions-gradient-${this.useFixedActionBox ? 'fixed' : 'flowing'}`;
    },
  },
};
